import { render, staticRenderFns } from "./ReturnTable.vue?vue&type=template&id=e5e66ea4&scoped=true"
import script from "./ReturnTable.vue?vue&type=script&lang=js"
export * from "./ReturnTable.vue?vue&type=script&lang=js"
import style0 from "./ReturnTable.vue?vue&type=style&index=0&id=e5e66ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e66ea4",
  null
  
)

export default component.exports